<template>
  <register-container style="height: 100%" :contentStyle="{ height: '100%', position: 'relative' }">
    <div
      style="
        margin: auto;
        max-width: 800px;
        position: absolute;
        inset: 0;
        height: fit-content;
        max-height: 100%;
      "
      class="pa-2 text-center flex-grow-1"
    >
      <div v-if="error" class="d-flex flex-column align-center" style="gap: 16px">
        <v-icon :size="$vuetify.breakpoint.mdAndUp ? '100' : '50'" color="error">
          mdi-alert-circle
        </v-icon>
        <p class="mb-0">
          {{ error }}
        </p>
        <p style="font-size: 0.7rem; font-style: italic" class="mt-0">
          Please see pharmacist for assistance.
        </p>
      </div>
      <TruformeLoader v-else> Generating invoice... </TruformeLoader>
    </div>
  </register-container>
</template>
<script>
import CREATE_INVOICE from '@/graphql/Mutation/CreateInvoice.gql';
import FINALIZE_INVOICE from '@/graphql/Mutation/FinalizeInvoice.gql';
import RegisterContainer from '../components/RegisterContainer.vue';
import TruformeLoader from '../components/Truforme/TruformeLoader.vue';

export default {
  name: 'TruformeCreateInvoice',
  components: {
    RegisterContainer,
    TruformeLoader,
  },
  data() {
    return {
      error: null,
      productId: '3O3ADVC7N3IMYPKNPPB57I7W',
    };
  },
  computed: {
    memberId() {
      return this.$store.state.registration.memberId;
    },
  },
  methods: {
    end() {
      window.dispatchEvent(new CustomEvent('GO_NEXT_PAGE'));
    },
    onNextClick() {},
    async finalizeInvoice(id) {
      try {
        const data = await this.$apollo.mutate({
          mutation: FINALIZE_INVOICE,
          variables: {
            stripeInvoiceId: id,
            providerId: this.$store.getters.getProviderId(),
          },
        });
        const invoice = data?.data?.finalizeInvoice;
        const { hostedInvoiceUrl } = invoice;
        if (!hostedInvoiceUrl) throw new Error('Cannot generate payable invoice URL');
        return invoice;
      } catch (error) {
        throw new Error('Could not finalize invoice');
      }
    },
    async createInvoice() {
      try {
        const data = await this.$apollo.mutate({
          mutation: CREATE_INVOICE,
          variables: {
            providerId: this.$store.getters.getProviderId(),
            memberId: this.memberId,
            lineItems: [this.productId],
            autoFinalize: true,
          },
        });

        return data?.data?.createInvoice;
      } catch (e) {
        throw new Error('Could not generate payable invoice');
      }
    },
    async generateBill() {
      this.loading = true;
      let invoice;
      try {
        invoice = await this.createInvoice();
      } catch (e) {
        invoice = null;
        this.error = e;
      }
      if (!invoice) {
        this.error = 'Could not generate payable invoice';
      } else {
        this.$store.commit('setRegistration', { invoice });
        window.dispatchEvent(new CustomEvent('GO_NEXT_PAGE'));
      }
      this.loading = false;
    },
  },
  mounted() {
    this.$store.commit('setOnNextClick', () => {
      if (this.isPageflowV2) {
        this.$emit('next');
      } else {
        this.$router.push({ name: this.$store.getters.nextFlowRoute(this.$route.name) });
      }
    });
    if (this.invoice?.hostedInvoiceUrl) {
      window.dispatchEvent(new CustomEvent('GO_NEXT_PAGE'));
    } else {
      this.generateBill();
    }
  },
};
</script>
